import React from 'react';
import 'moment/locale/nb.js';
import PropTypes from 'prop-types';
import { capitalizeFirst } from 'common/lib/helpers/TextUtils';
import {
    getDayOfMonth,
    getNameOfMonth,
    getNameOfWeekDay,
    getTimeOfDay,
    toIcalendarDateFormat,
} from 'common/lib/helpers/DateHelpers';

const Entry = ({ to, from, description, calendarUrl, finnkode, address }) => {
    const url = `${calendarUrl}?finnkode=${finnkode}&iCalendarFrom=${toIcalendarDateFormat(from)}${
        to ? `&iCalendarTo=${toIcalendarDateFormat(to)}` : ''
    }&eventLocation=${address}`;

    return (
        <li>
            <div>
                <p className="">{capitalizeFirst(getNameOfWeekDay(from))}</p>
            </div>
            <div className="flex flex-row flex-nowrap">
                <p className="font-bold ">{`${getDayOfMonth(from)}. ${getNameOfMonth(from)}`}</p>
                <p className="font-bold ml-64">{`${getTimeOfDay(from)}${to ? `–${getTimeOfDay(to)}` : ''}`}</p>
            </div>
            <div className="mt-8">
                <a href={url} className="font-bold" data-controller="trackAddToCalendar">
                    + Legg til i kalender
                </a>
            </div>
            {description ? <p className="text-12 mt-16 mb-0">{description}</p> : null}
        </li>
    );
};

Entry.propTypes = {
    to: PropTypes.object,
    from: PropTypes.object,
    description: PropTypes.string,
    calendarUrl: PropTypes.string,
    finnkode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    address: PropTypes.string,
};

export default Entry;
